export default {
  mobile: 700,
  tablet: 1199.9,
  desktop: 1200,
};
